export const ar = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.projects': 'خدماتنا',
  'nav.timeline': 'المسيرة',
  'nav.team': 'الفريق',
  'nav.contact': 'اتصل بنا',
  'nav.admin': 'لوحة التحكم',
  'nav.digitalTeam': 'فريق RS الرقمي',

  // Hero Section
  'hero.est': 'تأسس 2021 | فريق RS',
  'hero.brand': 'RED SHADOWS | RS',
  'hero.title': 'RED SHADOWS | RS',
  'hero.subtitle': 'فريق تطوير برمجيات شغوف ومبتكر يلتزم ببناء حلول قوية ومميزة وفعالة',
  'hero.cta': 'اكتشف خدماتنا',

  // Sections
  'section.projects': 'مجالات الخبرة',
  'section.tech': 'التقنيات',
  'section.timeline': 'مسيرتنا',
  'section.team': 'فريق العمل',
  'section.faq': 'الأسئلة الشائعة',
  'section.contact': 'تواصل معنا',

  // Admin
  'admin.login': 'بوابة الإدارة',
  'admin.username': 'اسم المستخدم',
  'admin.password': 'كلمة المرور',
  'admin.access': 'تسجيل الدخول',
  'admin.credentials': 'يرجى إدخال بيانات الاعتماد للمتابعة',
  'admin.invalid': 'البيانات غير صحيحة. حاول مرة أخرى',
  'admin.backLogin': 'عودة',
  'admin.dashboard': 'لوحة التحكم',
  'admin.manage': 'أدر المحتوى الرقمي بكفاءة واحترافية',
  'admin.back': 'عودة للموقع',
  'admin.logout': 'تسجيل الخروج',
  'admin.switchLanguage': 'تغيير اللغة',
  'admin.addProject': 'خدمة جديدة',
  'admin.addTeam': 'عضو جديد',
  'admin.addTimeline': 'محطة جديدة',
  'admin.editProject': 'تعديل الخدمة',
  'admin.editTeam': 'تعديل العضو',
  'admin.editTimeline': 'تعديل المحطة',
  'admin.addFaq': 'سؤال جديد',
  'admin.update': 'حفظ التغييرات',
  'admin.edit': 'تعديل',
  'admin.delete': 'حذف',
  'admin.cancel': 'إلغاء',
  'admin.confirmDelete': 'تأكيد الإجراء',
  'admin.deleteWarning': 'هل أنت متأكد من رغبتك في حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء',

  // Forms
  'form.title': 'العنوان',
  'form.desc': 'الوصف',
  'form.image': 'صورة الغلاف',
  'form.category': 'التصنيف',
  'form.name': 'الاسم الكامل',
  'form.role': 'المسمى الوظيفي',
  'form.year': 'السنة',
  'form.month': 'الشهر',
  'form.technologies': 'حزمة التقنيات',
  'form.upload': 'اسحب وأفلت أو اضغط للرفع',
  'form.submit': 'إنشاء العنصر',
  'form.features': 'المميزات الرئيسية',
  'form.bttnType': 'زر الإجراء',
  'form.linkUrl': 'الرابط المستهدف',
  'form.email': 'البريد الإلكتروني',
  'form.github': 'Github',
  'form.discord': 'Discord',
  'form.whatsapp': 'WhatsApp',

  // Validation
  'validation.required': 'يرجى ملء جميع الحقول المطلوبة',
  'validation.imageRequired': 'صورة الغلاف مطلوبة',
  'validation.required.titleEn': 'العنوان بالإنجليزية مطلوب',
  'validation.required.titleAr': 'العنوان بالعربية مطلوب',
  'validation.required.descriptionEn': 'الوصف بالإنجليزية مطلوب',
  'validation.required.descriptionAr': 'الوصف بالعربية مطلوب',
  'validation.required.nameEn': 'الاسم بالإنجليزية مطلوب',
  'validation.required.nameAr': 'الاسم بالعربية مطلوب',
  'validation.required.roleEn': 'المسمى الوظيفي بالإنجليزية مطلوب',
  'validation.required.roleAr': 'المسمى الوظيفي بالعربية مطلوب',
  'validation.required.year': 'السنة مطلوبة',

  // Placeholders
  'placeholder.service': 'مثال: تطوير تطبيقات الويب',
  'placeholder.tech': 'مثال: React, TypeScript, Node.js',
  'placeholder.github': 'مثال: username',
  'placeholder.discord': 'مثال: 145608354495070208',
  'placeholder.whatsapp': 'مثال: +966 50 123 4567',
  'placeholder.email': 'مثال: name@example.com',
  'placeholder.year': 'مثال: 2024',
  'placeholder.month': 'مثال: يناير',
  'placeholder.title': 'مثال: منصة تجارة إلكترونية',
  'placeholder.name': 'مثال: سارة محمد',
  'placeholder.role': 'مثال: مصممة واجهات',
  'placeholder.descEn': 'مثال: حل شامل للتجارة الإلكترونية...',
  'placeholder.descAr': 'مثال: حل شامل للتجارة الإلكترونية...',
  'placeholder.milestoneDesc': 'مثال: الوصول لـ 100 ألف مستخدم...',
  'placeholder.features': 'مثال: سريع، آمن، قابل للتوسع',
  'placeholder.link': 'مثال: https://example.com',

  // Options
  'option.noButton': 'بلا إجراء',
  'option.visitSite': 'رابط الموقع',
  'option.visitSource': 'رابط الكود',

  // Footer
  'footer.rights': 'جميع الحقوق محفوظة',
  'footer.madeWith': 'صنع بكل حب',
  'footer.byTeam': 'بواسطة RED SHADOWS | RS',

  // Months
  'month.jan': 'يناير',
  'month.feb': 'فبراير',
  'month.mar': 'مارس',
  'month.apr': 'أبريل',
  'month.may': 'مايو',
  'month.jun': 'يونيو',
  'month.jul': 'يوليو',
  'month.aug': 'أغسطس',
  'month.sep': 'سبتمبر',
  'month.oct': 'أكتوبر',
  'month.nov': 'نوفمبر',
  'month.dec': 'ديسمبر',

  // Contact
  'contact.emailTitle': 'راسلنا',
  'contact.emailDesc': 'نسعى للرد خلال 24 ساعة',
  'contact.discordTitle': 'المجتمع',
  'contact.discordDesc': 'انضم لمجتمعنا على ديسكورد',
  'contact.send': 'إرسال الرسالة',
  'contact.visitSite': 'زيارة الموقع',
  'contact.visitSource': 'عرض المصدر',
  'contact.emailLabel': 'بريدك الإلكتروني',
  'contact.sent': 'تم إرسال رسالتك بنجاح!',
  'contact.failed': 'تعذر الإرسال. يرجى المحاولة مرة أخرى',
  'contact.joinServer': 'انضم للسيرفر',

  // Language
  'lang.enCode': 'EN',
  'lang.arCode': 'AR',

  // Errors
  'error.404.title': '404',
  'error.404.subtitle': 'الصفحة غير موجودة',
  'error.404.message': 'الصفحة التي تبحث عنها قد تم حذفها، أو تم تغيير اسمها، أو أنها غير متاحة مؤقتًا.',
  'error.500.title': '500',
  'error.500.subtitle': 'خطأ في الخادم',
  'error.500.message': 'حدث خطأ ما من جانبنا. يرجى محاولة تحديث الصفحة أو العودة لاحقًا.',
  'error.backHome': 'العودة للرئيسية',
  'error.tryAgain': 'حاول مرة أخرى',
};
